"use client";import{Panel as o,Tab as t,Tabs as a,Root as s}from"./BoxTab.parts.js";
/**
 * BoxTab 컴포넌트
 * @module BoxTab
 * @description 탭 기반 네비게이션을 구현하는 컴포넌트입니다.
 * @property {Component} Root - 탭 컨테이너
 * @property {Component} Tabs - 탭 목록
 * @property {Component} Tab - 탭
 * @property {Component} Panel - 탭 패널
 * @example
 * ```tsx
 * import BoxTab from './BoxTab';
 *
 * function Example() {
 *   return (
 *     <BoxTab.Root>
 *       <BoxTab.Tabs>
 *         <BoxTab.Tab index={0} href="/">첫 번째 탭</BoxTab.Tab>
 *         <BoxTab.Tab index={1} href="/">두 번째 탭</BoxTab.Tab>
 *       </BoxTab.Tabs>
 *       <BoxTab.Panel index={0}>첫 번째 패널 내용</BoxTab.Panel>
 *       <BoxTab.Panel index={1}>두 번째 패널 내용</BoxTab.Panel>
 *     </BoxTab.Root>
 *   );
 * }
 * ```
 */const e={Root:s,Tabs:a,Tab:t,Panel:o};export{e as BoxTab};
